/** PNG icons under `public/assets/womens wear/` and `public/assets/women shirt /` */
const WOMENS_WEAR_ASSET_BASE = `${process.env.PUBLIC_URL || ''}/assets/womens wear`;
const WOMEN_SHIRT_ASSET_BASE = `${process.env.PUBLIC_URL || ''}/assets/women shirt `;

function womenWearIcon(filename) {
  return `${WOMENS_WEAR_ASSET_BASE}/${filename}`;
}

function womenShirtIcon(relativePath) {
  return `${WOMEN_SHIRT_ASSET_BASE}/${relativePath}`;
}

export const WOMEN_GARMENT_TYPE_ICON_BY_VALUE = {
  dress: womenWearIcon('Dress.png'),
  frock: womenWearIcon('Dress.png'),
  top: womenWearIcon('Top.png'),
  shirt: womenShirtIcon('Neck line /Classic collar_.png'),
  skirt: womenWearIcon('Skirt.png'),
  tshirt: womenWearIcon('T- shirt.png'),
  jeans: womenWearIcon('Bottom.png'),
  trouser: womenWearIcon('Bottom.png'),
  shorts: womenWearIcon('Bottom.png'),
  lehenga: womenWearIcon('Lehenga.png'),
  blouses: womenWearIcon('Blouse.png'),
  'saree-styles': womenWearIcon('Saree.png'),
  'night-wear': womenWearIcon('Nightwear.png'),
  lingerie: womenWearIcon('Lingerie.png'),
  blazer: womenWearIcon('Jackets.png'),
  hoodies: womenWearIcon('Jackets.png'),
  layering: womenWearIcon('Jackets.png'),
  jacket: womenWearIcon('Jackets.png'),
  sweater: womenWearIcon('Jackets.png'),
  socks: womenWearIcon('socks.png'),
};

export function getWomenGarmentTypeIcon(typeValue) {
  if (!typeValue) return null;
  const normalized = String(typeValue).toLowerCase();
  if (normalized === 'shirt' || normalized.startsWith('shirt-')) {
    return WOMEN_GARMENT_TYPE_ICON_BY_VALUE.shirt;
  }
  return WOMEN_GARMENT_TYPE_ICON_BY_VALUE[typeValue] || null;
}
